export enum UploadRowStatus {
  Pending = "pending",
  Uploading = "uploading",
  Uploaded = "uploaded",
  Failed = "failed",
}
